import React, { Fragment } from "react";
import {
  XMarkIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";
import { Dialog, Transition } from "@headlessui/react";
import IconButton from "../../../iconButton";
import Button from "../../../button";

const AdminDeleteProfessionsSlideOver = ({
  show,
  setShowSlide,
  handleClose,
  text
}) => {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden dashboard_calander_slideover">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-10 md:pt-[70px] md:pb-5 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="border-b border-solid border-[#CCD0D4] pb-3 md:pb-5 mb-4 md:mb-5">
                      <XMarkIcon
                        className="w-[64px] md:w-20 h-[64px] md:h-20 p-4 cursor-pointer text-[#EF2121] bg-[#FFEBEB] rounded-[10px]"
                        onClick={handleClose}
                      />
                      <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E] mt-6 md:mt-[30px]">
                        Are you sure you want to delete the {text}?
                      </Dialog.Title>
                    </div>
                    <p className="text-sm md:text-base font-normal leading-[160%] text-[#485868] mb-6 md:mb-[30px]">
                      Deleting a {text} removes all of its assigned
                      Specialties. Please be sure you have approval for deleting
                      this {text}, and double check you are deleting the right
                      one. This action cannot be undone.
                    </p>
                    <div className="grid grid-cols-1 gap-4">
                      <IconButton
                        title="YES, I AM SURE"
                        icon={CheckCircleIcon}
                        classes={`flex items-center bg-[#EF2121] text-sm md:text-base rounded-[10px] font-black uppercase text-white leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                        onClick={handleClose}
                        iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
                      />
                      <Button
                        title="CANCEL"
                        classes={`flex items-center bg-[#EBEFF3] text-sm md:text-base rounded-[10px] text-[#485868] font-black uppercase leading-[160%] h-10 md:h-[58px] w-full justify-center cursor-pointer`}
                        onClick={handleClose}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AdminDeleteProfessionsSlideOver;
